// extracted by mini-css-extract-plugin
export default {"textItem":"SLCarousel_textItem__tXxbr","imageItem":"SLCarousel_imageItem__fTalW","listItems":"SLCarousel_listItems__14cWo"};